/**
 * PostHog Feature Flag Keys
 * Central place for all PostHog feature flag constants
 *
 * Usage:
 *   import { FeatureFlagKeys } from '../constants/ff.posthog';
 *   const isEnabled = useFeatureFlag(FeatureFlagKeys.credentialingV2);
 */

export const FeatureFlagKeys = {
  credentialingV2: 'TEMP-13770-credentialing-v2',
  bestInDentalAdminPanel: 'GOTU-5623-best-in-dental-admin-panel',
  blockAddChildToOfficeWithCompletedShifts:
    'GOTU-4592-block-add-child-to-office-with-completed-shifts',
  dsoManagersFromAuthService: 'GOTU-6387-dso-managers-from-auth-service',
  gotuAdminsAdminPanel: 'GOTU-5861-gotu-admins-admin-panel',
  // Gates the Location Users surfaces under GOTU-7482 — the list (GOTU-19601)
  // and the identity profile (GOTU-19602), with its Locations tab to come in
  // GOTU-19603 — which all read this one key.
  locationUsersAdminPanel: 'GOTU-7482-location-users-admin-panel',
  // The office apps' A/B test (GOTU-13065), so not this repo's `…-admin-panel`
  // naming. Read only as the office through `evaluateFlagForDistinctId`, never
  // through posthog-js, which would answer for the signed-in admin.
  likelyToFillIndicator: 'GOTU-13065-likely-to-fill-indicator',
  // Read the office-profile slice of a DNT profile from org-service (via the
  // admin-authed monolith /admin/office route) instead of /admin/users/:id.
  // `admin-portlal` is the deliberate spelling — it matches the GOTU-5263
  // ticket's PostHog key and this repo's own name verbatim. The key must equal
  // the PostHog flag exactly, so do NOT "correct" it to `admin-portal`, or
  // `isFeatureEnabled` returns false forever and the read path never runs.
  officeSliceRead: 'GOTU-5263-admin-portlal-office-read',
  // `transparancy` is misspelled in PostHog. The key has to match the flag
  // verbatim, so the typo stays until the flag itself is renamed.
  officeReviewsRatingTransparency:
    'GOTU-6266-enforce-office-reviews-rating-transparancy-and-tag-based-feedback',
  recruitersFromAuthService: 'GOTU-6388-recruiters-from-auth-service',
  // Sources the RAM lists from organization-service's sales metros and makes
  // the office profile's RAM field read-only. Keyed to the epic (GOTU-6007),
  // unlike the entries above, because GOTU-6009 flips with it.
  salesMetrosAdminPanel: 'GOTU-6007-sales-metros-admin-panel',
  // The monolith's own switch (tempmee_server, GOTU-7543), mirrored here so the
  // RAM filters send the reserved Unassigned metro's id only once the monolith
  // resolves it. Not this repo's `…-admin-panel` naming because the backend
  // owns the key: it must equal that flag verbatim.
  salesMetrosSwitch: 'GOTU-6007-sales-metros-switch',
};
